











import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { PostRequest } from '@/store/requeststate';
import { BookmarkBean } from '@/types';

@Component({})
export default class BookmarkForm extends Vue {
    @Action('post', {namespace: 'requestState'})
    public post!: (req: PostRequest) => Promise<any>;

    private bookmark: BookmarkBean = {
        bookmarkId: '',
        title: '',
        url: '',
        tags: '',
        counter: 0,
    };

    private async save() {
        await this.post({path: 'api/bookmark/save', params: {}, data: this.bookmark});
        location.reload();
    }
}
